import request from "@/utils/request"
import { BatchOptTaskListRequest, DeviceBatchTaskInsertDtoRequest, PageRequest, RBooleanResponse, RListDeviceBatchTaskItemVoResponse, RListDeviceBatchTaskVoResponse, RListPairIntegerResponse, RListPairStringResponse } from "./define"

/**
 * 获取批量操作任务
 */
export function getBatchOptTaskList(params: BatchOptTaskListRequest) {
    return request.get<RListDeviceBatchTaskVoResponse>('/api/v2/deviceBatchTask/list', {

        params
    })
}

/**
 * 获取所有功能类型枚举
 */
export function getAllFuncTypes() {
    return request.get<RListPairStringResponse>('/api/v2/deviceBatchTask/funcTypeEnum')
}

/**
 * 获取所有任务状态枚举
 */
export function getAllTaskStatuses() {
    return request.get<RListPairIntegerResponse>('/api/v2/deviceBatchTask/statEnum')
}
/**
 * 创建批量操作任务
 */
export function createBatchOptTask(data: DeviceBatchTaskInsertDtoRequest) {
    return request.post<RBooleanResponse>('/api/v2/deviceBatchTask/insert', data)
}

/**
 * 查询批量操作任务详情
 */
export function getBatchOptTaskDetail(id: number, params?: PageRequest) {
    return request.get<RListDeviceBatchTaskItemVoResponse>(`/api/v2/deviceBatchTask/${id}`, { params })
}